import { IActor } from '@/types'
import { IScript } from '@/types/cinematics'
import { useCinematicsStore } from '@/cinematics/stores/CinematicsStore'

//TODO Scenario: Scene with more than 1 Actor and Script
export const useActorScript = (sceneId: string) => {
  const { cinematics } = useCinematicsStore()

  const scene = cinematics?.scenes?.[sceneId]

  return {
    _id: scene?._id ?? '',
    route: scene?.route ?? '',
    actors: scene?.actors[0] ?? {} as IActor,
    script: scene?.script[0] ?? {} as IScript,
    set: scene?.set ?? {},
    transitions: scene?.transitions ?? [] as any[],
  }
}
